export enum CodeSettingsEnum {
    TimeSession = 'time_session',
    DayMouse = 'day_mouse',
    DossierEditing = 'dossier_editing',
    PasswordAlarm = 'password_alarm',
    PasswordHistory = 'password_history',
    CountAttempt = 'count_attempt',
    PasswordDay = 'password_day',
    ArchivingPeriod = 'archiving_period',
}
